import { createSelector } from '@ngrx/store'
import { AppState } from '../app.state'
import { StageState } from './stage.state'

export const getStage = (state: AppState) => state.stage

export const getUser = createSelector(getStage, (state: StageState) => state.user)

export const getStatuses = createSelector(getStage, (state: StageState) => state.statuses)

export const getVisibilities = createSelector(getStage, (state: StageState) => state.visibilities)

export const getMeasuringPurpose = createSelector(getStage, (state: StageState) => state.measuringPurpose)

export const getSectors = createSelector(getStage, (state: StageState) => state.sectors)

export const getTechnologies = createSelector(getStage, (state: StageState) => state.technologies)

export const getCountries = createSelector(getStage, (state: StageState) => state.countries)

export const getPNOCountryResponsibles = createSelector(getStage, (state: StageState) => state.pnoCountryResponsibles)

export const getIsLoadingChangePassword = createSelector(getStage, (state: StageState) => state.isLoadingChangePassword)

export const selectAccountInfo = createSelector(getStage, (state: StageState) => state.accountInfo)

export const getIsLoadingAvatar = createSelector(getStage, (state: StageState) => state.isLoadingAvatar)

export const getUserAvatar = createSelector(getStage, (state: StageState) => state.avatar)

export const getPathLocationPrevious = createSelector(getStage, (state: StageState) => state.pathLocationPrevious)

export const getUserNotifications = createSelector(getStage, (state: StageState) => state.userNotifications)

export const getIsLoadingUserNotifications = createSelector(getStage, (state: StageState) => state.isLoadingUserNotifications)
